/**
 * Finds selected values that don't exist in a given data list.
 * Works with any data type — users, locations, teams, etc.
 *
 * @param {string|number|Array} selectedValues - Currently selected value(s)
 * @param {Array} dataList - The available data items
 * @param {string} [idKey="id"] - The key to use for matching IDs in dataList
 * @returns {string[]} Array of IDs that are not found in dataList
 */
export const getUnmatchedValues = (
  selectedValues,
  dataList = [],
  idKey = "id",
  labelFormatter = id => `Unknown User (ID: ${id})`
) => {
  if (!selectedValues) return [];
  const selected = Array.isArray(selectedValues) ? selectedValues : [selectedValues];
  const knownIds = new Set(dataList.map(item => String(item[idKey])));
  return selected
    .filter(id => !knownIds.has(String(id)))
    .map(id => ({ id, label: labelFormatter(id) }));
};

export const arraysAreEqual = (a, b) => {
  if (!a || !b) return false;
  if (!Array.isArray(a) || !Array.isArray(b)) return false;
  if (a.length !== b.length) return false;

  const idsA = a.map(item => Number(item.id));
  const idsB = b.map(item => Number(item.id));

  for (let i = 0; i <= idsA.length; i++) {
    if (idsA[i] !== idsB[i]) {
      return false;
    }
  }
  return true;
};
